import {createRouter, createWebHashHistory, RouteRecordRaw} from "vue-router";
import Dashboard from "@/views/Dashboard.vue"
import Products from "@/views/Products.vue"
import Payments from "@/views/Payments.vue"
import PaymentLinks from "@/views/PaymentLinks.vue"
import LessonAccesses from "@/views/LessonAccesses.vue"
import NotFound from "@/views/NotFound.vue"
import Login from "@/views/Login.vue"
import Lessons from "@/views/Lessons.vue"
import store from "@/store";
import Files from "@/views/Files.vue";
import LessonProducts from "@/views/LessonProducts.vue";
import LessonProductDiscounts from "@/views/LessonProductDiscounts.vue";
import LessonProductOptions from "@/views/LessonProductOptions.vue";
import Notices from "@/views/Notices.vue";
import NoticeDetail from "@/views/NoticeDetail.vue";
import LoginAccessCodes from "@/views/LoginAccessCodes.vue";
import LessonContentUnlockCodes from "@/views/LessonContentUnlockCodes.vue";
import LessonPopups from "@/views/LessonPopups.vue";
import PaymentNotices from "@/views/PaymentNotices.vue";
import OfflineLessons from "@/views/OfflineLessons.vue";
import AccessCodePaymentAudit from "@/views/AdvancedAccessCodePaymentAudit.vue";
import AdvancedClassLessonAccesses from "@/views/AdvancedClassLessonAccesses.vue";
import AdvancedAccessCodePaymentAudit from "@/views/AdvancedAccessCodePaymentAudit.vue";
import BasicAccessCodePaymentAudit from "@/views/BasicAccessCodePaymentAudit.vue";
import LearningSessions from "@/views/LearningSessions.vue";
import NoticeModals from "@/views/NoticeModals.vue";
import TeamLeaderAccessCodes from "@/views/TeamLeaderAccessCodes.vue";
import KakaoManagement from "@/views/KakaoManagement.vue";
import PtTeacherKakaoManagement from "@/views/PtTeacherKakaoManagement.vue";
import Staffs from "@/views/Staffs.vue";
import MenuManagement from "@/views/MenuManagement.vue";
import AlimtalkTemplates from "@/views/AlimtalkTemplates.vue";
import AlimtalkSendRequests from "@/views/AlimtalkSendRequests.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { layout: "empty" },
  },
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    meta: { authorization: true },
  },
  {
    path: "/products",
    name: "Products",
    component: Products,
    meta: { authorization: true },
  },
  {
    path: "/payment-links",
    name: "PaymentLinks",
    component: PaymentLinks,
    meta: { authorization: true },
  },
  {
    path: "/payments",
    name: "Payments",
    component: Payments,
    meta: { authorization: true },
  },
  {
    path: "/lesson-accesses",
    name: "LessonAccesses",
    component: LessonAccesses,
    meta: { authorization: true },
  },
  {
    path: "/advance-lesson-accesses",
    name: "AdvancedClassLessonAccesses",
    component: AdvancedClassLessonAccesses,
    meta: { authorization: true },
  },
  {
    path: "/lessons",
    name: "Lessons",
    component: Lessons,
    meta: { authorization: true },
  },
  {
    path: "/files",
    name: "Files",
    component: Files,
    meta: { authorization: true },
  },
  {
    path: "/lesson_products",
    name: "LessonProducts",
    component: LessonProducts,
    meta: { authorization: true },
  },
  {
    path: "/lesson_product_discounts",
    name: "LessonProductDiscounts",
    component: LessonProductDiscounts,
    meta: { authorization: true },
  },
  {
    path: "/lesson_product_options",
    name: "LessonProductOptions",
    component: LessonProductOptions,
    meta: { authorization: true },
  },
  {
    path: "/notices",
    name: "Notices",
    component: Notices,
    meta: { authorization: true },
  },
  {
    path: "/notice/:id",
    name: "NoticeDetail",
    component: NoticeDetail,
    meta: { authorization: true },
  },
  {
    path: "/lesson_content_unlock_codes",
    name: "LessonContentUnlockCodes",
    component: LessonContentUnlockCodes,
    meta: { authorization: true },
  },
  {
    path: "/popup",
    name: "LessonPopups",
    component: LessonPopups,
    meta: { authorization: true },
  },
  {
    path: "/payment-notices",
    name: "PaymentNotices",
    component: PaymentNotices,
    meta: { authorization: true },
  },
  {
    path: "/offline-lessons",
    name: "OfflineLessons",
    component: OfflineLessons,
    meta: { authorization: true },
  },
  {
    path: "/access-code-payment/basic",
    name: "BasicAccessCodePaymentAudit",
    component: BasicAccessCodePaymentAudit,
    meta: { authorization: true },
  },
  {
    path: "/access-code-payment/advanced",
    name: "AdvancedAccessCodePaymentAudit",
    component: AdvancedAccessCodePaymentAudit,
    meta: { authorization: true },
  },
  {
    path: "/learning-session",
    name: "LearningSessions",
    component: LearningSessions,
    meta: { authorization: true },
  },
  {
    path: "/notice-modal",
    name: "NoticeModals",
    component: NoticeModals,
    meta: { authorization: true },
  },
  {
    path: "/team-leader-access-codes",
    name: "TeamLeaderAccessCodes",
    component: TeamLeaderAccessCodes,
    meta: { authorization: true },
  },
  {
    path: "/menus",
    name: "MenuManagement",
    component: MenuManagement,
    meta: { authorization: true },
  },
  {
    path: "/staffs",
    name: "Staffs",
    component: Staffs,
    meta: { authorization: true },
  },
  {
    path: "/kakao-management",
    name: "KakaoManagement",
    component: KakaoManagement,
    meta: { authorization: true },
  },
  {
    path: "/pt-teacher-kakao-management",
    name: "PtTeacherKakaoManagement",
    component: PtTeacherKakaoManagement,
    meta: { authorization: true },
  },
  {
    path: "/alimtalk-templates",
    name: "AlimtalkTemplates",
    component: AlimtalkTemplates,
    meta: { authorization: true },
  },
  {
    path: "/alimtalk-templates/new",
    name: "AlimtalkTemplateCreate",
    component: AlimtalkTemplates,
    meta: { authorization: true },
  },
  {
    path: "/alimtalk-templates/:id",
    name: "AlimtalkTemplateDetail",
    component: AlimtalkTemplates,
    meta: { authorization: true },
  },
  {
    path: "/alimtalk-send-requests",
    name: "AlimtalkSendRequests",
    component: AlimtalkSendRequests,
    meta: { authorization: true },
  },
  {
    path: "/alimtalk-send-requests/:id",
    name: "AlimtalkSendRequestDetail",
    component: AlimtalkSendRequests,
    meta: { authorization: true },
  },
  { path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { layout: "empty" },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const { authorization } = to.meta;
  if(authorization) {
    const localStorageToken = localStorage.ACCESS_TOKEN
    const token = store.state.token.accessToken
    if(!localStorageToken && !token) return next({ path: "/login" });
  }
  
  next();
})

export default router;
